var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "added-button" },
    [
      _c("circledCheckIcon"),
      _vm._v(" "),
      _c("span", { staticClass: "added-button-label" }, [
        _vm._v(_vm._s(_vm.label))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f1c6a75", { render: render, staticRenderFns: staticRenderFns })
  }
}